export enum MapSize {
  LARGE = 'LARGE',
  SMALL = 'SMALL',
  HIDDEN = 'HIDDEN',
}
